const black = {
   50: '#FAFAFA',
   100: '#F5F5F5',
   200: '#EEEEEE',
   300: '#E0E0E0',
   400: '#BDBDBD',
   500: '#9E9E9E',
   600: '#757575',
   700: '#616161',
   800: '#2A2A2B',
   900: '#212121',
   A100: '#121212',
   A200: '#111111',
   A400: '#010101',
   A700: '#000000'
}

export default black
